import SessionNode from './SessionNode';
import AgentNode from './AgentNode';
import ArtifactNode from './ArtifactNode';
import PhaseNode from './PhaseNode';
import AnnotationNode from './AnnotationNode';

export const nodeTypes = {
  session: SessionNode,
  agent: AgentNode,
  artifact: ArtifactNode,
  phase: PhaseNode,
  annotation: AnnotationNode,
};
